import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import App from './App'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import * as serviceWorker from './serviceWorker'

import getSubdomain from './utils/getSubdomain'

import './i18n/config'

if (process.env.NODE_ENV !== 'production') {
  const axe = require('@axe-core/react')
  axe(React, ReactDOM, 1001, {})
}

const rootNode = document.getElementById('root')
const lang = rootNode?.getAttribute('lang') || 'en'
const languageToggleLink = rootNode?.getAttribute('lang-toggle-link') || ''
const loginUrl = rootNode?.getAttribute('login-url') || `https://${getSubdomain(process.env.REACT_APP_MY_MEDICARE_ENV || '')}mymedicare.gov`
const logoutUrl = rootNode?.getAttribute('logout-url') || `https://${getSubdomain(process.env.REACT_APP_MY_MEDICARE_ENV || '')}mymedicare.gov/signout.aspx`
const enableLiveChat = rootNode?.getAttribute('enable-live-chat') === 'true'

ReactDOM.render(
  <React.StrictMode>
    <App lang={lang} languageToggleLink={languageToggleLink} loginUrl={loginUrl!} logoutUrl={logoutUrl!} enableLiveChat={enableLiveChat} />
  </React.StrictMode>,
  rootNode
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
